"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _visualInterest = require("@decisiv/design-tokens/lib/color/visual-interest");

var _commonUIColors = require("../../utils/commonUIColors");

var _SimplePrimary = _interopRequireDefault(require("./SimplePrimary"));

var _StyledFilter = _interopRequireDefault(require("./StyledFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var components = {
  simple: _SimplePrimary.default
}; // variant uses basic

var Filter = (0, _react.forwardRef)(function (_ref, ref) {
  var filterActive = _ref.active,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'simple' : _ref$variant,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'primary' : _ref$kind,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? 'information' : _ref$badgeColor,
      rest = _objectWithoutProperties(_ref, ["active", "variant", "kind", "onClick", "disabled", "badgeColor"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var Component = components[variant];
  var toggleStatus = (0, _react.useCallback)(function () {
    return setActive(!active);
  }, [active, setActive]);
  var handleOnClick = (0, _react.useCallback)(function (e) {
    if (typeof onClick === 'function') {
      onClick(e);
    } else {
      toggleStatus();
    }
  }, [onClick, toggleStatus]);
  return _react.default.createElement(_StyledFilter.default, _extends({
    ref: ref,
    kind: kind,
    tabIndex: 0,
    active: filterActive || active,
    onClick: handleOnClick,
    disabled: disabled
  }, rest), _react.default.createElement(Component, _extends({
    active: active,
    disabled: disabled,
    badgeColor: disabled ? _visualInterest.VisualInterestColorName.licoriceMousse : badgeColor
  }, rest)));
}); // @ts-ignore

Filter.propTypes = {
  active: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['simple']),
  kind: _propTypes.default.oneOf(['primary']),
  onClick: _propTypes.default.func,
  text: _propTypes.default.string.isRequired,
  badgeColor: _propTypes.default.oneOf(_commonUIColors.commonUIColorKeys),
  badgeIcon: _propTypes.default.elementType,
  count: _propTypes.default.number,
  disabled: _propTypes.default.bool
};
Filter.defaultProps = {
  active: false,
  variant: 'simple',
  onClick: undefined,
  kind: 'primary',
  badgeIcon: undefined,
  badgeColor: 'information',
  count: undefined,
  disabled: false
};
Filter.displayName = 'Filter';
var _default = Filter;
exports.default = _default;